(ns pfo.chat.tool-component
  (:require
   #_:clj-kondo/ignore
   [taoensso.timbre :as timbre
    :refer [log trace debug info warn error fatal report logf
            tracef debugf infof warnf errorf fatalf reportf spy]]
   [reagent.core :as r :refer [atom track!] :refer-macros [with-let]]
   [promesa.core :as p]
   [clojure.data :refer [diff]]
   [clojure.string :as str]
   [pfo.api :as api  :refer [process-error]]
   [pfo.admin.component :as admin :refer [contact-user-add]]
   [pfo.admin.model :refer [group-admin-permitted-users]]
   [pfo.auth.model :as auth-model]
   [pfo.controller :as controller :refer [subscribe]]
   [pfo.collection.component :as collection]
   [pfo.collection.model :as collection-model]
   [pfo.coltype.component :as coltype-component :refer [collection-type-form coltype-template-data-sources]]
   [pfo.coltype.components.details :as coltype]
   [pfo.coltype.model :as coltype-model]
   [pfo.document.component :as document]
   [pfo.document.model :as document-model]
   [pfo.form :as form]
   [pfo.task.component :as task]
   [pfo.task.model :as task-model]
   [pfo.chat.common-component :refer [markdown-message add-sidebar-panel]]
   [pfo.chat.tool.collection :as tool-collection]
   [cljs-time.format :as time-fmt]
   [cljs-time.coerce :as time-coerce]
   [pfo.util :as util]
   [pfo.chat.tool.collection-component :as col-tool]
   [pfo.assignment.component :refer [assignments-edit-notable-redesign assignments-to-id-set get-initial-ui-assignments]]))

(declare
 confirm-action
 create-collection-in-chat
 default-tool
 retrieve-fields
 help-tooltip)

(def catom clojure.core/atom)

(defn collection-edit-sidebar-panel [options collection-type-form-component title active]
  (with-let []
    [:div.cs-expansion-panel__inside [:span {:on-click (util/handler
                                                        (fn []
                                                          (some-> (:on-toggle-open options) (apply []))))} title]
     (when active
       [:div
        [:div
         [collection-type-form-component]]])]))

(defn collection-edit-sidebar-panels [options get-collection-type-form-fn form-def *active-form]
  [:div (doall (map
                (fn [{:keys [index label]}]
                  ^{:key index}
                  [collection-edit-sidebar-panel (merge options
                                                        {:on-toggle-open (fn [] (if (= @*active-form index)
                                                                                  (reset! *active-form nil)
                                                                                  (reset! *active-form index)))})
                   (partial get-collection-type-form-fn index)
                   label (= @*active-form index)]) (filter identity (:forms form-def))))])

(defn segment-header [_ field-status]
  [:div.o-media.c-segment-header-extra-content #_(str
                                                  (count (filter (fn [[_ status]] (= status :status/approved)) field-status))
                                                  " / "
                                                  (count field-status)
                                                  " Approved")])

(defn field-controls [{:keys [approve-cb
                              reject-cb
                              edit-cb]} _]
  [:div.c-field-controls
   [:input.svg-icon--md {:type :image
                         :src "/static/img/icons/edit.svg"
                         :on-click (util/handler edit-cb)}]
   #_[:input.svg-icon--md {:type :image
                           :style {:position :relative
                                   :top "-0.25em"}
                           :src "/static/img/icons/delete.svg"
                           :on-click (util/handler reject-cb)}]
   #_[:button {:on-click (util/handler approve-cb)} "Approve"]])

(defn help-tooltip [help-component]
  (with-let [*show-tooltip (atom false)]
    [:div.c-info-tooltip
     [:img.c-info-icon {:src "/static/img/icons/info.svg"
                        :on-click (util/handler #(swap! *show-tooltip not))}]
     (when @*show-tooltip
       [:div.c-tooltip-popup
        [:div.c-tooltip-text
         help-component]])]))

(defn user-vertical-list [users]
  (let [users (or users [])]
    [:div.c-user-vertical-list
     (doall
      (map (fn [u]
             ^{:key (:id u)} [:div.c-user-vertical-list__item (auth-model/get-full-name u)])
           users))]))


(defn permissions [options family-id *parent-id *permitted-user-ids]
  (with-let [*family-permitted-users (atom nil)
             *parent-permitted-users (atom nil)
             set-user-ids (fn [family-permitted-ids permitted-ids]
                            (reset! *permitted-user-ids (into #{} (filterv #(contains? family-permitted-ids %) permitted-ids))))
             load-permitted-users (fn [collection-id users-atom]
                                    (controller/dispatch :permitted-users :load {:collection-ids collection-id
                                                                                 :regular-only true
                                                                                 :on-success (fn [response]
                                                                                               (reset! users-atom response))}))
             *parent (subscribe :collection-details)
             _ (controller/dispatch :collection-details :clear)
             _ (controller/dispatch :collection-details :load {:collection-id @*parent-id})
             _ (load-permitted-users family-id *family-permitted-users)
             _ (load-permitted-users @*parent-id *parent-permitted-users)
             _ (add-watch *parent-id :parent-changed (fn [_ _ old-parent updated-parent] 
                                                       (when-not (= old-parent updated-parent)
                                                         (do
                                                           (controller/dispatch :collection-details :load {:collection-id updated-parent})
                                                           (load-permitted-users updated-parent *parent-permitted-users)))))] 
    (when @*parent
      [:div
       [:h3 "Set Permissions"]
       (when (:batch-create options)
         [:div.u-padding-bottom--xs "This will overide any permissions set on the individual collections"])
       [:div.u-padding-bottom--xs.u-font-weight--bolder.u-font-size--smaller  "Select all users that should have access to this collection"]
       [:div.u-padding-bottom--xs
        (when-not (:hide-populate-from-parent options)
          [:<>
           [:button.c-button--small {:on-click (util/handler
                                                (fn []
                                                  (set-user-ids (into #{} (mapv #(:id %) @*family-permitted-users)) (mapv #(:id %) @*parent-permitted-users))))} "Populate from Parent"]
           [help-tooltip
            [:div
             [:h4 (str (:name @*parent) " (parent) gives access to the following users:")]
             [user-vertical-list @*parent-permitted-users]]]])
        [:div
         [:label.u-padding-top--xs
          [:input {:type "checkbox"
                   :checked (= (count @*family-permitted-users) (count @*permitted-user-ids))
                   :ref (fn [el] (when el (set! (.-indeterminate el) (and (> (count @*permitted-user-ids) 0)
                                                                          (< (count @*permitted-user-ids) (count @*family-permitted-users))))))
                   :on-change (fn [ev]
                                (if (= (count @*family-permitted-users) (count @*permitted-user-ids))
                                  (reset! *permitted-user-ids #{})
                                  (reset! *permitted-user-ids (set (map :id @*family-permitted-users)))))}] [:span.u-font-weight--bolder "Select All"]]]
        [:ul
         (doall
          (for [{user-id :id
                 :as user} @*family-permitted-users]
            [:li {:key (:id user)}
             [:label
              [:input (form/set-checked
                       (contains? @*permitted-user-ids user-id)
                       {:on-click (fn [ev]
                                    (let [selected (-> ev .-target .-checked)]
                                      (if selected
                                        (swap! *permitted-user-ids conj user-id)
                                        (swap! *permitted-user-ids disj user-id))))})]
              (auth-model/get-full-name user)]]))]]])))

(defn create-collection [{:keys [*sidebar-panels
                                 *disabled
                                 *selected-family-id
                                 register-confirm-action-fn
                                 tool-update-success-cb
                                 family-id]
                          :as options}
                         system-message-obj
                         {{:as args} :arguments
                          :as tool-call}]
  (with-let [*parent-id (atom (:parent_id args))
             *parent-name (atom nil)
             *name (atom (:name args))
             *collection-type-id (atom (:collection_type_id args))
             *coltype (atom nil)
             *create-review (atom (:create_review args))
             *permitted-user-ids (atom #{})
             *expanded (atom (not (:batch-create options)))
             _ (register-confirm-action-fn (fn []
                                             (let [args (merge args
                                                               {:parent_id @*parent-id
                                                                :name @*name
                                                                :collection_type_id (util/somestr-to-int @*collection-type-id)
                                                                :create_review @*create-review})]
                                               (controller/dispatch
                                                :chat-tool-call
                                                :update-args
                                                {:tool-call-id (:id tool-call)
                                                 :args args
                                                 :system-args {:permitted_user_ids @*permitted-user-ids}
                                                 :success-cb tool-update-success-cb}))))
             _ (when (:*batch-permitted-user-ids options)
                 (add-watch (:*batch-permitted-user-ids options) (str "batch-permitted-user-ids-changed-" (:id tool-call))
                            (fn [_ _ old-permitted-user-ids new-permitted-user-ids]
                              (reset! *permitted-user-ids new-permitted-user-ids))))
             _ (when (:*parent-id-atoms options)
                 (add-watch *parent-id (str "parent-id-" (:id tool-call))
                            (fn [_ _ old-parent-id new-parent-id]
                              (reset! (get (:*parent-id-atoms options) (:id tool-call)) new-parent-id))))]
    
    [:div 
     (when-not (:batch-create options) [:h2.u-margin-top--xs "Create collection"])
     [:div.cs-collection-create {:class (when (:batch-create options) "Batch")}
      (when (:batch-create options)
        [:div.cs-expander {:class (if @*expanded "expanded" "collapsed")
                           :on-click (util/handler #(swap! *expanded not))}
         [:img {:src "/static/img/icons/arrow-expand.svg" :alt "expand-collapse"}]])
      [:div.cs-collection-content
       (when (:batch-create options)
         [:div.o-space-between.u-padding-bottom
          [:div.u-display--flex.u-align-items--center
           [:div
            [:div.u-font-weight--bolder @*name]
            [:div.u-color--secondary.u-font-size--smaller (get-in @*coltype [:asset_type :name]) ": " (:name @*coltype)]
            [:div.u-color--secondary.u-font-size--smaller "Parent: " @*parent-name]]]
          [:div.cs-permissions {:class (if (empty? @*permitted-user-ids) "NotSet" "Set")} (if (empty? @*permitted-user-ids) "User permissions not set" "User permissions set")]])
       [:div  (when-not @*expanded {:class "u-display--none"})
        [collection/collection-details-edit
         {:forms-change-status-atom (catom {})
          :form-class "c-form--edit"
          :active-form :details
          :disable-save true
          :hide-form-header true
          :allow-parent-choice true
          :hide-active true
          :value-atoms {:name *name
                        :collection-type-id *collection-type-id
                        :coltype *coltype
                        :create-review *create-review
                        :parent-name *parent-name}}
         nil
         *parent-id
         family-id]
        [:div.c-divider.u-padding-bottom--xs] 
        [permissions (assoc options 
                            :hide-populate-from-parent (= @*parent-id family-id)) family-id *parent-id *permitted-user-ids]]]]]))

(defn set-collection-status [{:keys [*sidebar-panels
                                     *disabled
                                     *selected-family-id
                                     register-confirm-action-fn
                                     tool-update-success-cb]
                              :as options}
                             system-message-obj
                             {{:as args} :arguments
                              :as tool-call}]
  (let [{:keys [collection_id collection_name active]} args
        status-text (if active "active" "inactive")]
    (with-let [_ (register-confirm-action-fn (fn []
                                               (controller/dispatch
                                                :chat-tool-call
                                                :update-args
                                                {:tool-call-id (:id tool-call)
                                                 :args args
                                                 :success-cb tool-update-success-cb})))]
      [:div
       [:div "Collection " [:strong collection_name] " will be set as " [:strong status-text]]])))

(defn- get-all-refs
  "Recursively collects the :ref of a field and all its sub-fields into a flat list."
  [field]
  (when field
    (cons (:ref field)
          (mapcat get-all-refs (:subfields field)))))

(defn- find-field-by-ref
  "Recursively searches through a collection of fields to find the first
  one with a matching :ref value."
  [fields target-ref]
  (reduce
   (fn [_ field]
     (if (= (:ref field) target-ref)
       (reduced field) ; Found it, short-circuit and return the field
       (when-let [found-in-sub (find-field-by-ref (:subfields field) target-ref)]
         (reduced found-in-sub)))) ; Found in a nested level, short-circuit
   nil
   fields))

(defn retrieve-fields
  "Given a collection of fields and a starting :ref, finds the matching
  field and returns a flat vector of its :ref and all its descendant :refs.
  Returns an empty vector if the ref is not found."
  [fields-data start-ref]
  (if-let [starting-field (find-field-by-ref fields-data start-ref)]
    (vec (get-all-refs starting-field))
    []))

(defn confirm-action [chat-conversation-id *disabled]
  (reset! *disabled true)
  (controller/dispatch
   :chat-messages
   :confirm
   {:conversation-id chat-conversation-id}))

(defn create-task-or-compliance [type]
  (fn [{:keys [*sidebar-panels
               *disabled
               *selected-family-id
               register-confirm-action-fn
               tool-update-success-cb]
        :as options}
       system-message-obj
       {{family-id :family_collection_id
         collection-ids :collection_ids
         template-group-id :template_id
         date :date
         user-ids :user_ids
         :as args} :arguments
        :as tool-call}]
    (with-let [*task-type (atom type)
               *users (atom nil)
               *errors (atom nil)
               *perm-types (atom #{})
               _ (->> (auth-model/permission-types [collection-ids])
                      (p/map (fn [types]
                               (reset! *perm-types types)))
                      (process-error))
               can-add-step #(contains? @*perm-types (if (= @*task-type :compliance) :can_add_compliance :can_add_task))
               _ (->> (collection-model/permitted-users (if (= :compliance @*task-type)
                                                          {:compliance-assign true}
                                                          {:task-assign true}) collection-ids)
                      (p/map (fn [response] (reset! *users response)))
                      (process-error))
               *collections (atom nil)
               *assignments (atom nil)
               *primary-collection-id-global (atom (str (first collection-ids)))
               *assignments-to-delete (atom #{})
               *include-inactive-collections (atom false)
               _ (->>
                  (p/all (mapv (fn [collection-id] (collection-model/collection-details collection-id)) collection-ids))
                  (p/map (fn [collections]
                           (reset! *collections collections)
                           (reset! *assignments (get-initial-ui-assignments (mapv (fn [col] {:collection_id (:id col)
                                                                                             :collection col}) collections)))))
                  (process-error))
               *template-group-id (atom (str template-group-id))
               *date (atom (when date (time-coerce/to-date (time-fmt/parse (time-fmt/formatter "yyyy-MM-dd") date))))
               *user-ids (atom user-ids)
               _ (register-confirm-action-fn (fn []
                                               (let [args (merge args
                                                                 {:collection_ids (assignments-to-id-set @*assignments)
                                                                  :date (util/local-date-time-to-date-string @*date)
                                                                  :user_ids (mapv (comp util/somestr-to-int not-empty) @*user-ids)
                                                                  :template_id (util/str->int @*template-group-id)
                                                                  :main_collection_id (util/str->int @*primary-collection-id-global)})]
                                                 (controller/dispatch
                                                  :chat-tool-call
                                                  :update-args
                                                  {:tool-call-id (:id tool-call)
                                                   :args args
                                                   :success-cb tool-update-success-cb}))))]
      (when @*collections
        [:div.o-media--margin
         [:h2 "Create " (if (= :compliance @*task-type) "Compliance" "Task") " from Template"]
         [assignments-edit-notable-redesign
          {:include-inactive-atom *include-inactive-collections
           :collection-label "Collection*"}
          *assignments
          *errors
          nil
          *assignments-to-delete
          (atom family-id)
          *primary-collection-id-global]

         [task/apply-from-template-details-form
          {:allow-change-template-group true
           :set-to-today true
           :hide-assign-to-label true
           :calendar-icon true
           :hide-teplate-details-header true
           :assign-setps-label "Assign steps to users *"
           :user-chooser-opts {:fuzzy true
                               :class "u-width--60"
                               :class-prefix "form-select"
                               :theme :second}
           :step-legend-class "cs-step-legend"}
          (atom family-id)
          *perm-types
          *task-type
          *errors
          *users
          can-add-step
          nil
          (atom false)
          {:template-group-id *template-group-id
           :complete-by *date
           :user-ids *user-ids}]]))))

(defn create-document [{:keys [*sidebar-panels
                               *disabled
                               *selected-family-id
                               register-confirm-action-fn
                               tool-update-success-cb]
                        :as options}
                       system-message-obj
                       {{family-id :family_collection_id
                         collection-ids :collection_ids
                         category-id :category_id
                         custom-name :custom_name
                         year :year
                         quarter :quarter
                         month :month
                         day :day
                         upload-id :upload_id
                         main-collection-id :main_collection_id
                         :as args} :arguments
                        :as tool-call}]
  (with-let [*collections (atom nil)
             _ (->>
                (p/all (mapv (fn [collection-id] (collection-model/collection-details collection-id)) collection-ids))
                (p/map (fn [collections] (reset! *collections collections)))
                (process-error))
             *document-form-action-fn (atom nil)
             _ (register-confirm-action-fn (fn [] (@*document-form-action-fn)))]
    (when @*collections
      [:div
       [document/document-edit-form
        {:disable-group-choice false
         :disable-upload true
         :disable-headers true
         :disable-ext-ref true
         :disable-back true
         :upload-id upload-id
         :disable-controls true
         :register-submit-action-fn (fn [action-fn] (reset! *document-form-action-fn action-fn))
         :on-submit (fn [_ _ doc]
                      (controller/dispatch
                       :chat-tool-call
                       :update-args
                       {:tool-call-id (:id tool-call)
                        :args (merge args
                                     {:collection_ids (mapv util/str->int (:collection-ids doc))
                                      :year (util/somestr-to-int (:year doc))
                                      :month (util/somestr-to-int (:month doc))
                                      :quarter (util/somestr-to-int (:quarter doc))
                                      :category_id (util/somestr-to-int (:category-id doc))
                                      :day (util/somestr-to-int (:day doc))
                                      :custom_name (:name doc)
                                      :main_collection_id (util/somestr-to-int (:main-collection-id doc))})
                        :success-cb tool-update-success-cb}))}
        nil
        {:name custom-name
         :category_id category-id
         :year year
         :quarter quarter
         :month month
         :day day
         :document_collections (map-indexed (fn [index col]
                                              {:collection_id (:id col)
                                               :collection col
                                               :main (= main-collection-id (:id col))}) @*collections)}
        nil
        [{:id family-id}]]])))

(defn file-staged-submission
  "Confirm card of file_staged_submission (#2928). The name comes from the
  review queue, not from the model's arguments, so the reviewer sees which
  staged document the confirmation files."
  [_ _ {{document-id :document_id} :arguments}]
  (let [items (subscribe :staging-queue)]
    ;; The chat page does not load the queue, and a reload empties it.
    (controller/dispatch :staging-queue :load nil)
    (fn [options system-message-obj tool-call]
      (let [item (some #(when (= document-id (:id %)) %) @items)
            ;; The form starts in the family the model named, which can be wrong;
            ;; the server files only into the submission's family.
            family-id (or (:family_id item) (get-in tool-call [:arguments :family_collection_id]))]
        [:div
         [:h2 (if item (str "File " (:name item)) "File the staged document")]
         ^{:key family-id}
         [create-document options system-message-obj
          (assoc-in tool-call [:arguments :family_collection_id] family-id)]]))))

(defn create-note [{:keys [*sidebar-panels
                           *disabled
                           *selected-family-id
                           register-confirm-action-fn
                           tool-update-success-cb]
                    :as options}
                   system-message-obj
                   {{family-id :family_collection_id
                     collection-ids :collection_ids
                     category-id :category_id
                     custom-name :custom_name
                     year :year
                     quarter :quarter
                     month :month
                     day :day
                     body :body
                     main-collection-id :main_collection_id
                     ;; upload-id :upload_id
                     :as args} :arguments
                    :as tool-call}]
  (with-let [*collections (atom nil)
             _ (->>
                (p/all (mapv (fn [collection-id] (collection-model/collection-details collection-id)) collection-ids))
                (p/map (fn [collections] (reset! *collections collections)))
                (process-error))
             *document-form-action-fn (atom nil)
             _ (register-confirm-action-fn (fn [] (@*document-form-action-fn)))]
    (when @*collections
      [:div
       [document/document-edit-form
        {:disable-group-choice false
         :disable-upload true
         :disable-headers true
         :disable-ext-ref true
         :disable-back true
         :disable-controls true
         :register-submit-action-fn (fn [action-fn] (reset! *document-form-action-fn action-fn))
         :on-submit (fn [_ _ doc]
                      (controller/dispatch
                       :chat-tool-call
                       :update-args
                       {:tool-call-id (:id tool-call)
                        :args (merge args
                                     {:collection_ids (mapv util/str->int (:collection-ids doc))
                                      :body (:body doc)
                                      :year (util/somestr-to-int (:year doc))
                                      :month (util/somestr-to-int (:month doc))
                                      :quarter (util/somestr-to-int (:quarter doc))
                                      :category_id (util/somestr-to-int (:category-id doc))
                                      :day (util/somestr-to-int (:day doc))
                                      :custom_name (:name doc)
                                      :main_collection_id (util/somestr-to-int (:main-collection-id doc))})
                        :success-cb tool-update-success-cb}))}
        nil
        {:doc_type "n"
         :body body
         :name custom-name
         :category_id category-id
         :year year
         :quarter quarter
         :month month
         :day day
         :document_collections (map-indexed (fn [index col]
                                              {:collection_id (:id col)
                                               :collection col
                                               :main (= main-collection-id (:id col))}) @*collections)}
        nil
        [{:id family-id}]]])))

(defn update-document [{:keys [*sidebar-panels
                               *disabled
                               *selected-family-id
                               register-confirm-action-fn
                               tool-update-success-cb]
                        :as options}
                       system-message-obj
                       {{document-id :document_id
                         family-id :family_collection_id
                         category-id :category_id
                         collection-ids :collection_ids
                         custom-name :custom_name
                         year :year
                         quarter :quarter
                         month :month
                         day :day
                         upload-id :upload_id
                         main-collection-id :main_collection_id
                         :as args} :arguments
                        :as tool-call}]
  (with-let [*family-id (atom family-id)
             _ (->>
                (document-model/document-details document-id)
                (p/map (fn [doc]
                         (->>
                          (collection-model/collection-details (get-in doc [:document_collections 0 :collection_id]))
                          (p/map (fn [col]
                                   (reset! *family-id (:group_id col))))
                          (process-error))))
                (process-error));;
             *collections (atom nil)
             _ (->>
                (p/all (mapv (fn [collection-id] (collection-model/collection-details collection-id)) collection-ids))
                (p/map (fn [collections] (reset! *collections collections)))
                (process-error))
             *document-form-action-fn (atom nil)
             _ (register-confirm-action-fn (fn [] (@*document-form-action-fn)))]
    (when @*collections
      [:div
       [document/document-edit-form
        {:disable-group-choice false
         :disable-upload true
         :disable-headers true
         :disable-ext-ref true
         :disable-controls true
         :disable-back true
         :upload-id upload-id
         :register-submit-action-fn (fn [action-fn] (reset! *document-form-action-fn action-fn))
         :on-submit (fn [_ _ doc]
                      (controller/dispatch
                       :chat-tool-call
                       :update-args
                       {:tool-call-id (:id tool-call)
                        :args (merge args
                                     {:collection_ids (mapv util/str->int (:collection-ids doc))
                                      :year (util/somestr-to-int (:year doc))
                                      :month (util/somestr-to-int (:month doc))
                                      :quarter (util/somestr-to-int (:quarter doc))
                                      :category_id (util/somestr-to-int (:category-id doc))
                                      :day (util/somestr-to-int (:day doc))
                                      :custom_name (:name doc)
                                      :main_collection_id (util/somestr-to-int (:main-collection-id doc))})
                        :success-cb tool-update-success-cb}))}
        nil
        {:name custom-name
         :year year
         :quarter quarter
         :month month
         :day day
         :category_id category-id
         :document_collections (map-indexed (fn [index col]
                                              {:collection_id (:id col)
                                               :collection col
                                               :main (= main-collection-id (:id col))}) @*collections)}
        nil
        [{:id @*family-id}]]])))

(defn update-note [{:keys [*sidebar-panels
                           *disabled
                           *selected-family-id
                           register-confirm-action-fn
                           tool-update-success-cb]
                    :as options}
                   system-message-obj
                   {{document-id :document_id
                     body :body
                     family-id :family_collection_id
                     category-id :category_id
                     collection-ids :collection_ids
                     custom-name :custom_name
                     year :year
                     quarter :quarter
                     month :month
                     day :day
                     upload-id :upload_id
                     main-collection-id :main_collection_id
                     :as args} :arguments
                    :as tool-call}]
  (with-let [*family-id (atom family-id)
             _ (->>
                (document-model/document-details document-id)
                (p/map (fn [doc]
                         (->>
                          (collection-model/collection-details (get-in doc [:document_collections 0 :collection_id]))
                          (p/map (fn [col]
                                   (reset! *family-id (:group_id col))))
                          (process-error))))
                (process-error));;
             *collections (atom nil)
             _ (->>
                (p/all (mapv (fn [collection-id] (collection-model/collection-details collection-id)) collection-ids))
                (p/map (fn [collections] (reset! *collections collections)))
                (process-error))
             *document-form-action-fn (atom nil)
             _ (register-confirm-action-fn (fn [] (@*document-form-action-fn)))]
    (when @*collections
      [:div
       [document/document-edit-form
        {:disable-group-choice false
         :disable-upload true
         :disable-headers true
         :disable-ext-ref true
         :disable-controls true
         :disable-back true
         :upload-id upload-id
         :register-submit-action-fn (fn [action-fn] (reset! *document-form-action-fn action-fn))
         :on-submit (fn [_ _ doc]
                      (controller/dispatch
                       :chat-tool-call
                       :update-args
                       {:tool-call-id (:id tool-call)
                        :args (merge args
                                     {:collection_ids (mapv util/str->int (:collection-ids doc))
                                      :body (:body doc)
                                      :year (util/somestr-to-int (:year doc))
                                      :month (util/somestr-to-int (:month doc))
                                      :quarter (util/somestr-to-int (:quarter doc))
                                      :category_id (util/somestr-to-int (:category-id doc))
                                      :day (util/somestr-to-int (:day doc))
                                      :custom_name (:name doc)
                                      :main_collection_id (util/somestr-to-int (:main-collection-id doc))})
                        :success-cb tool-update-success-cb}))}
        nil
        {:name custom-name
         :doc_type "n"
         :body body
         :year year
         :quarter quarter
         :month month
         :day day
         :category_id category-id
         :document_collections (map-indexed (fn [index col]
                                              {:collection_id (:id col)
                                               :collection col
                                               :main (= main-collection-id (:id col))}) @*collections)}
        nil
        [{:id @*family-id}]]])))

(defn create-contact [{:keys [*sidebar-panels
                              *disabled
                              *selected-family-id
                              register-confirm-action-fn
                              tool-update-success-cb]
                       :as options}
                      system-message-obj
                      {{family-id :family_id
                        first-name :first_name
                        middle-name :middle_name
                        last-name :last_name
                        suffix :suffix
                        email :email
                        phone-number :phone_number
                        company-name :company_name
                        title :title
                        birth-date :birth_date
                        citizenship-status :citizenship_status
                        physical-address-line-1 :physical_address_line_1
                        physical-address-line-2 :physical_address_line_2
                        physical-address-city :physical_address_city
                        physical-address-state :physical_address_state
                        physical-address-zip :physical_address_zip
                        physical-address-country :physical_address_country
                        physical-address-type :physical_address_type
                        ssn-ein :ssn_ein
                        fin-cen-id :fincen_id
                        minor-child :minor_child
                        exempt-entity :exempt_entity
                        legal-name :legal_name
                        id-type :id_type
                        id-country :id_country
                        id-state :id_state
                        id-number :id_number
                        :as args} :arguments
                       :as tool-call}]
  (with-let [*contact-form-action-fn (atom nil)
             _ (register-confirm-action-fn (fn [] (@*contact-form-action-fn)))]
    [:div
     [admin/contact-edit
      {:disable-controls true
       :highlighted-by-fin-cen-id-fn (fn [_])
       :fincen-id-not-required-fn (fn [_] (fn [] true))
       :disable-id-document-upload true
       :disable-coltact true
       :register-submit-action-fn (fn [action-fn] (reset! *contact-form-action-fn action-fn))
       :title "Create contact"
       :name-fields-inline true
       :show-more true
       :calendar-icon true
       :on-submit (fn [updated-args]
                    (controller/dispatch
                     :chat-tool-call
                     :update-args
                     {:tool-call-id (:id tool-call)
                      :args (merge args updated-args)
                      :success-cb tool-update-success-cb}))}
      {:family_id family-id
       :first_name first-name
       :middle_name middle-name
       :last_name last-name
       :suffix suffix
       :email email
       :phone_number phone-number
       :company_name company-name
       :title title
       :birth_date birth-date
       :citizenship_status citizenship-status
       :physical_address_line_1 physical-address-line-1
       :physical_address_line_2 physical-address-line-2
       :physical_address_city physical-address-city
       :physical_address_state physical-address-state
       :physical_address_zip physical-address-zip
       :physical_address_country physical-address-country
       :physical_address_type physical-address-type
       :ssn_ein ssn-ein
       :fin_cen_id fin-cen-id
       :minor_child minor-child
       :exempt_entity exempt-entity
       :legal_name legal-name
       :id_type id-type
       :id_country id-country
       :id_state id-state
       :id_number id-number
       :as args} :arguments
      [{:id family-id}]]]))

(defn chip [label]
  [:span.chip label])

(defn card [{:keys [title subtitle chips]}]
  [:div.card
   [:div.card__title title]
   (when subtitle
     [:div.card__subtitle subtitle])
   (when (seq chips)
     [:div.card__chips
      (for [c chips]
        ^{:key c} [chip c])])])

(defn link-records [_ {parent-name :parent_name
                       parent-additional-info :parent_additional_info
                       child-name :child_name
                       child-additional-info :child_additional_info}]
  [:section.link-records
   [:div.link-records__header
    [:h3.link-records__title "Link Records"]
    #_[:p.link-records__desc
       "Additional information about linking records if applicable. "
       "This could be static information or information provided by AARK about why its "
       "suggesting this action"]]

   [:div.link-records__grid
    [card {:title parent-name
           ;; :subtitle "Collection / Path / For document"
           :chips [parent-additional-info]}]

    [:div.link-records__link-icon
     ;; swap with your icon component if you have one
     [:span "↔"]]

    [card {:title child-name
           ;; :subtitle "Compliance that it applies to"
           :chips [child-additional-info]}]]])

(defn link-objects [{:keys [*sidebar-panels
                            *disabled
                            *selected-family-id
                            register-confirm-action-fn
                            tool-update-success-cb]
                     :as options}
                    system-message-obj
                    {{:as args} :arguments
                     :as tool-call}]
  (with-let [_ (register-confirm-action-fn tool-update-success-cb)]
    (when true
      [link-records nil args])))

(defn toggle-task-complete [{:keys [*sidebar-panels
                                    *disabled
                                    *selected-family-id
                                    register-confirm-action-fn
                                    tool-update-success-cb]
                             :as options}
                            system-message-obj
                            {{task-name :task_name
                              task-group-name :task_group_name
                              step-number :step_number
                              occurrence :occurrence
                              complete :complete} :arguments
                             :as tool-call}]
  (with-let [_ (register-confirm-action-fn tool-update-success-cb)
             task-name (str
                        (when task-group-name (str task-group-name ": "))
                        (if (and step-number (> step-number 0))
                          (task-model/step-name (dec step-number) task-name)
                          task-name))]
    [:p.u-margin-bottom
     (str "Setting task '" task-name "' for occurrence on "
          occurrence " to "
          (if complete "complete" "incomplete") ".")]))



(defn default-tool [{:keys [*disabled]} system-message-obj tool-call]
  (with-let [disable-buttons (atom false)]
    [:p
     [markdown-message nil (:meta tool-call) #_(:content system-message-obj)]]))

(defn document-summary-result [{:keys [register-confirm-action-fn
                                       tool-update-success-cb]
                                :as _options}
                               _system-message-obj
                               {_args :arguments
                                {:keys [document_name existing_summary]} :meta
                                :as _tool-call}]
  (with-let [_ (register-confirm-action-fn tool-update-success-cb)]
    [:div
     [:h2 (str "Save Summary for " document_name)]
     [:p "The saved summary will be accessible in the document smart record."]
     (when existing_summary
       (let [user-name (or (some-> (:created_user existing_summary) auth-model/get-full-name not-empty) "Unknown")
             date      (util/date-reformat (:created_at existing_summary))]
         [:div.c-warning-box
          [:img {:src "/static/img/icons/review-alerttriangle.svg"}]
          [:span (str "Saving this new summary will overwrite the existing summary created by "
                      user-name " on " date ".")]]))]))

(defn generate-document-summary [{:keys [register-confirm-action-fn
                                         tool-update-success-cb]
                                   :as _options}
                                  _system-message-obj
                                  {{additional-instructions :additional_instructions
                                    :as args} :arguments
                                   {:keys [document_name]} :meta
                                   :as tool-call}]
  (with-let [*instructions (atom (or additional-instructions ""))
             _ (register-confirm-action-fn
                (fn []
                  (controller/dispatch
                   :chat-tool-call
                   :update-args
                   {:tool-call-id (:id tool-call)
                    :args (assoc args :additional_instructions @*instructions)
                    :success-cb tool-update-success-cb})))]
    [:div
     [:h2 (str "Generate summary for " document_name)]
     [:div.u-margin-bottom
      [:textarea {:value @*instructions
                  :placeholder "Add instructions to focus, exclude, or shape the summary (optional)"
                  :on-change #(reset! *instructions (-> % .-target .-value))
                  :rows 4}]]]))

(defn tool [options system-message-obj tool-call]
  (with-let [*disabled (atom false)
             tool-component (case (:tool_name tool-call)
                              "create_collection" col-tool/create-collection
                              "update_collection" col-tool/update-collection
                              "set_collection_status" col-tool/set-collection-status
                              "update_collection_ownership" col-tool/update-collection-ownership
                              "update_collection_carried_interest_ownership" col-tool/update-collection-carried-interest-ownership
                              "update_collection_trust_beneficial_interest" col-tool/update-collection-trust-beneficial-interest
                              "create_compliance" (create-task-or-compliance :compliance)
                              "create_task" (create-task-or-compliance :task)
                              "create_document" create-document
                              "file_staged_submission" file-staged-submission
                              "update_document" update-document
                              "link_objects" link-objects
                              "create_note" create-note
                              "update_note" update-note
                              "toggle_task_complete" toggle-task-complete
                              "toggle_compliance_complete" toggle-task-complete
                              "create_contact" create-contact
                              "finalize_collection_review" col-tool/finalize-collection-review
                              "record_review_findings" col-tool/record-review-findings
                              "revise_review_findings" col-tool/revise-review-findings
                              "create_cadence_compliance" col-tool/create-cadence-compliance
                              "start_collection_review" col-tool/start-collection-review
                              "generate_document_summary" generate-document-summary
                              "document_summary_result" document-summary-result
                              default-tool)]
    [util/disable-tool {:disabled @*disabled
                        :class :u-non-clickable
                        :component [tool-component
                                    (assoc options
                                           :*disabled *disabled) system-message-obj tool-call]}]))

(defn create-collection-group [options tc-group message-obj]
  [col-tool/create-collection-group tool options tc-group message-obj])
